export default [
  {
    path: '/salary',
    name: 'Salary',
    component: () => import('./index.vue'),
    meta: {
      title: '成员薪资'
    }
  },
  {
    path: '/salary/detail',
    name: 'SalaryDetail',
    component: () => import('./detail.vue'),
    meta: {
      title: '薪资明细'
    }
  }
];
